import React, {Component} from "react";
import Footer from "features/layouts/footer";
import {array, bool, oneOf, string} from "prop-types";
import "./index.scss";
import logoWhite from "images/logo/marchio_osa.png";
import logoColor from "images/logo/marchio_osa_dark.png";
import Button from "features/components/button";
import HelpButton from "features/components/help-button";
import {__} from "services/i18n";
import {connect} from "react-redux";
import {resetAuth} from "store/reducer/auth/reducer";
import {Breadcrumbs} from "features/components/breadcrumbs";
import {SHOW_MESSENGER_FAB} from "constants.js";
import {historyObject} from "historyObject";

/* istanbul ignore next */
const mapStateToProps = state => ({

});
/* istanbul ignore next */
const mapDispatchToProps = {
    resetAuth
};

export class LoggedOutLayout extends Component {

    doLogout() {
        const {resetAuth} = this.props;
        resetAuth();
    }

    render() {
        const {type, className, showLogoutButton, breadcrumbs} = this.props;
        const isLight = type === "light";
        return (
            <div className={`layout-logged-out ${type} ${className}`}>
                <div className={"header"}>
                    <div className={"header-wrapper"}>
                        <img className={"logo"} src={isLight ? logoColor : logoWhite} alt={"Osa logo"} />
                       {/* <div className={"buttons"}>
                            <Button title={__("buttons.need-help")}
                                    onClick={() => { historyObject.push("/help") }}
                                    icon={"support"}
                                    type={isLight ? "default-type" : "accent"}
                            />
                            {showLogoutButton && <Button title={""}
                                                         onClick={() => this.doLogout()}
                                                         icon={"exit"}
                                                         type={"square"}
                            />}
                        </div>*/}

                    </div>
                </div>
                <Breadcrumbs items={breadcrumbs} />
                <div className="page-wrapper">
                    {this.props.children}
                </div>
                <Footer type={type} />
                {/* istanbul ignore next */SHOW_MESSENGER_FAB && <HelpButton/>}
            </div>
        )
    }
}

LoggedOutLayout.propTypes = {
    type: oneOf(["light", "dark"]).isRequired,
    className: string,
    showLogoutButton: bool,
    breadcrumbs: array
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutLayout);
